import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { TripsList } from '../../features/trips';
import { Banner, GlobalErrorPlug, Info, Loader } from '../../features/ui';
import {
  FilterWrapper,
  setLoadingTrips,
  setTrips,
  SORT_URL_NAME,
} from '../../features/filter';
import appStyles from '../../app/App.module.scss';
import styles from './FilterPage.module.scss';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { ReactComponent as Hello } from '../../assets/hello.svg';
import { ReactComponent as Wait } from '../../assets/wait.svg';
import { ReactComponent as Success } from '../../assets/success.svg';
import { ReactComponent as Failure } from '../../assets/failure.svg';
import classNames from 'classnames';
import { setCityKey } from '../../app/appSlice';
import { useSearchParams } from 'react-router-dom';
import { useGetTrips } from '../../features/api';

export default function FilterPage(): JSX.Element {
  const dispatch = useAppDispatch();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const root = document.getElementById('filter') as HTMLElement;
    const cityKey = root.dataset.cityKey;

    if (cityKey) {
      dispatch(setCityKey(cityKey));
    }
  }, []);

  const { t } = useTranslation();

  const selectedSortOption = searchParams.get(SORT_URL_NAME);
  const nothingFound = useAppSelector(state => state.filter.nothingFound);

  const { trips, isLoading, isError } = useGetTrips();

  const [showFilterSuccessMessage, setShowFilterSuccessMessage] =
    useState(false);

  //Установка сообщения, о том, что мы нашли, что нужно
  useEffect(() => {
    if (trips || selectedSortOption !== 'popularity') {
      setShowFilterSuccessMessage(true);
    } else {
      setShowFilterSuccessMessage(false);
    }
  }, [trips, selectedSortOption]);

  useEffect(() => {
    dispatch(setTrips(trips));
    dispatch(setLoadingTrips(isLoading));
  }, [trips, isLoading]);

  const [infoText, setInfoText] = useState('');
  const [infoGraphicElement, setInfoGraphicElement] =
    useState<React.ReactNode>();

  useEffect(() => {
    if (isLoading) {
      setInfoText(t('filter_loading'));
      setInfoGraphicElement(<Wait className={styles.infoIcon} />);
    } else if (nothingFound && !isLoading) {
      setInfoText(t('filter_failure'));
      setInfoGraphicElement(<Failure className={styles.infoIcon} />);
    } else if (showFilterSuccessMessage) {
      setInfoText(t('filter_success'));
      setInfoGraphicElement(<Success className={styles.infoIcon} />);
    } else {
      setInfoText(t('filter_hello'));
      setInfoGraphicElement(<Hello className={styles.infoIcon} />);
    }
  }, [isLoading, nothingFound, showFilterSuccessMessage]);

  if (isError) {
    return <GlobalErrorPlug />;
  }

  return (
    <>
      <Banner />

      <FilterWrapper className={styles.filter} />

      <div className={classNames(appStyles.container, styles.info)}>
        <Info
          graphicElement={infoGraphicElement}
          text={infoText}
        />
      </div>

      <div className={appStyles.container}>
        {isLoading && nothingFound ? (
          <Loader
            className={styles.tripsLoader}
            scale={0.8}
          />
        ) : (
          <TripsList />
        )}
      </div>
    </>
  );
}
